module.exports = __webpack_public_path__ + "img/steam2.302df9a0.png";